import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=f4ff5a48"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports